import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "../../../constants/queryKeys";
import { EngineEarsError } from "../../../store/actions/errorStore";
import { fetchProductsByReleaseId, ProductResponse } from "../productsAPI";

export const useFetchProductsByReleaseIdQuery = (releaseId = 0) => {
  return useQuery({
    enabled: Boolean(releaseId),
    queryKey: [
      QUERY_KEYS.FETCH_PRODUCTS_BY_RELEASE_ID,
      {
        releaseId,
      },
    ],
    queryFn: async () => {
      const response = await fetchProductsByReleaseId(releaseId);
      if (!response.success) {
        throw response.resultJson as EngineEarsError;
      }
      return response.resultJson as ProductResponse[];
    },
    refetchOnMount: false, // Don't refetch when component mounts if data exists
  });
};
